import { Mui } from '@osu/react-ui';
import Chip from './scoresChip';
import useStyles from '../../dd-styles';

const SATScores = (props) => {
  const { studentData } = props;

  if (!(studentData?.data?.scores?.sat?.length > 0)) {
      return (
        <>
          <Mui.Typography tabindex="0" aria-label='S A T' component="h3" variant="h6" key={1}>
            SAT
          </Mui.Typography>
          <Mui.Typography style={{marginLeft: '.5rem'}}>No test information available</Mui.Typography>
        </>
      )   
    }
  
  return (
    <> 
      <Mui.Typography tabindex="0" aria-label='S A T' component="h3" variant="h6" key={1}>
        SAT
      </Mui.Typography>
      {studentData?.data?.scores?.sat?.length > 0 ? (
        <> 
          <Mui.Box style={{display:'flex', flexWrap: 'wrap'}}>
            {studentData?.data?.scores?.sat?.map?.((item, index) => getScoreByType(item, index) )}
          </Mui.Box>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

function getScoreByType(item, index) {
    if (item.testId === "SSAT") { return <SsatScore item={item} index={index} />; }
    return <SatScore item={item} index={index} />;
}

function SatScore({ item, index }) {
    const classes = useStyles();
    return (
        <dl title="S A T" key={index} className={classes.dl}>
        <dd tabindex="0" className={classes.dd}>
          <Chip
            label={'Date'}
            childLabel={item.date ?? "N/A"}
          />
        </dd>
        {<dd tabindex="0" className={[classes.dd, classes.ddtestid].join(" ")}><Chip childLabel={item.testId} /></dd>}
        <dd tabindex="0" className={classes.dd}>
          <Chip
            label={'Total Score'}
            childLabel={item.total ?? "N/A"}
          />
        </dd>
        <dd tabindex="0" className={classes.dd}>
          <Chip
            label={'Math'}
            childLabel={item.math ?? "N/A"}
          />
        </dd>
        <dd tabindex="0" className={classes.dd}>
          <Chip
            label={'Evidence Based Read/Write'}
            childLabel={item.evidenceBased ?? "N/A"}
          />
        </dd>
        <dd tabindex="0" className={classes.dd}>
          <Chip
            label={'Reading'}
            childLabel={item.reading ?? "N/A"}
          />
        </dd>
        <Mui.Divider />
      </dl>  
    );
}

function SsatScore({ item, index }) {
    const classes = useStyles();
    return (
      <dl title="S A T" key={index} className={classes.dl}>
        <dd tabindex="0" className={classes.dd}> <Chip label="Date" childLabel={item.date ?? "N/A"} /> </dd>
        {<dd tabindex="0" className={[classes.dd, classes.ddtestid].join(" ")}><Chip childLabel={item.testId ?? "N/A"} /></dd>}
        <dd tabindex="0" className={classes.dd}> <Chip label="Critical Reading" childLabel={item.crvrb ?? "N/A"} /> </dd>
        <dd tabindex="0" className={classes.dd}> <Chip label="Math" childLabel={item.math ?? "N/A"} /> </dd>
        <dd tabindex="0" className={classes.dd}> <Chip label="Writing" childLabel={item.write ?? "N/A"} /> </dd>
        <dd tabindex="0" className={classes.dd}> <Chip label="Essay" childLabel={item.essay ?? "N/A"} /> </dd>
        <dd tabindex="0" className={classes.dd}> <Chip label="Multiple Choice Sub Score" childLabel={item.mcsub ?? "N/A"} /> </dd>
        <Mui.Divider />
      </dl>
    );
}

export default SATScores;
